import { Identifier } from "../../id";
export class ScheduleId extends Identifier {
    constructor(id) {
        super("ScheduleId", id);
    }
}
